import axios, { AxiosResponse } from 'axios';

import buildQueryOpts from '@/components/solicitud-filter/filter-utils';
import buildPaginationQueryOpts from '@/shared/sort/sorts';
import { IInstitucionSnp, InstitucionSnp } from '@/shared/model/snp/instituciones-snp.model';

const baseApiUrl = 'api/institucionesSnp';

export default class InstitucionesSnpService {
  public retrieve(paginationQuery?: any): Promise<AxiosResponse<Array<IInstitucionSnp>>> {
    return new Promise<AxiosResponse<Array<IInstitucionSnp>>>((resolve, reject) => {
      axios
        .get(baseApiUrl + `?${buildPaginationQueryOpts(paginationQuery)}${buildQueryOpts(paginationQuery.filter)}`)
        .then(res => resolve(res))
        .catch(err => reject(err));
    });
  }

  public registrarInstitucionDePersonasMorales(entity: InstitucionSnp): Promise<IInstitucionSnp> {
    return new Promise<IInstitucionSnp>((resolve, reject) => {
      axios
        .post(`${baseApiUrl}`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public obtenerByClaveInstitucionSNP(claveInstitucionSNP: string): Promise<IInstitucionSnp> {
    return new Promise<IInstitucionSnp>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/${claveInstitucionSNP}`)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
}
